// src/components/Support/StatusFlow.jsx
import React from 'react';
import { Box, Stepper, Step, StepLabel, StepContent, Typography, Paper } from '@mui/material';
import { SUPPORT_STATUSES } from '../../constants/supportConstants';

const StatusFlow = ({ currentStatus, completedAt, resolvedAt, closedAt }) => {
  const statusOrder = ['open', 'in-progress', 'waiting-for-seller', 'waiting-for-support', 'resolved', 'closed'];
  
  // Get the index of the current status
  const activeStep = statusOrder.indexOf(currentStatus);

  // Map statuses to steps with descriptions
  const steps = [
    {
      label: 'Open',
      description: 'Ticket has been submitted and is awaiting review',
      icon: '📩',
    },
    {
      label: 'In Progress',
      description: 'Support team is actively working on your issue',
      icon: '🔄',
    },
    {
      label: 'Waiting for Seller',
      description: 'Waiting for response from the seller',
      icon: '⏳',
    },
    {
      label: 'Waiting for Support',
      description: 'Waiting for response from support team',
      icon: '📨',
    },
    {
      label: 'Resolved',
      description: `Issue has been resolved ${resolvedAt ? new Date(resolvedAt).toLocaleDateString() : ''}`,
      icon: '✅',
    },
    {
      label: 'Closed',
      description: `Ticket is closed ${closedAt ? new Date(closedAt).toLocaleDateString() : ''}`,
      icon: '📁',
    },
  ];

  return (
    <Paper sx={{ p: 3, mt: 2 }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Ticket Status Flow
      </Typography>
      <Box sx={{ maxWidth: 600 }}>
        <Stepper activeStep={activeStep} orientation="vertical">
          {steps.map((step, index) => (
            <Step key={step.label} completed={index <= activeStep}>
              <StepLabel
                StepIconComponent={() => (
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: index <= activeStep ? 'primary.main' : 'grey.300',
                      color: index <= activeStep ? 'white' : 'text.secondary',
                      fontSize: 16,
                    }}
                  >
                    {step.icon}
                  </Box>
                )}
              >
                <Typography fontWeight={index === activeStep ? 'bold' : 'normal'}>
                  {step.label}
                </Typography>
              </StepLabel>
              <StepContent>
                <Typography variant="body2" color="text.secondary">
                  {step.description}
                </Typography>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Box>
    </Paper>
  );
};

export default StatusFlow;